<div class="user-management-heading-info">
    <div class="align-h width-stretch">
        <div class="stretch">Name</div>
        <div class="stretch">Employee ID</div>
        <div class="stretch">Mobile No</div>
        <div class="width-200 margin-right-10"></div>
    </div>
</div>
<mat-accordion>

    <mat-expansion-panel
        *ngFor="let ifa of ifaList"
        class="margin-bottom-20"
        (opened)="panelMap[ifa?.id] = true"
        (closed)="panelMap[ifa?.id] = false"
        [expanded]="panelMap[ifa?.id]"
    >
      <mat-expansion-panel-header>
                <div class="align-h width-stretch">
                    <div class="stretch">{{ ifa?.name }}</div>
                    <div class="stretch">{{ ifa?.arnCode }}</div>
                    <div class="stretch">{{ ifa?.mobile }}</div>
                    <div class="align-h width-200">
                        <div class="stretch">
                            <button
                                mat-icon-button
                                [color]="ifa?.isBlocked ? 'primary': 'secondary'"
                                (click)="$event.stopPropagation(); openBlockOrUnblockDialog(ifa)"
                            >
                                <mat-icon>block</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
        </mat-expansion-panel-header>
        <ng-template [ngIf]="panelMap[ifa?.id]">
            <div class="align-h width-stretch">
                <div class="stretch">Email ID: {{ ifa?.email }}</div>
                <div class="stretch">Pan: {{ ifa?.pan }}</div>
                <div class="stretch">
                    Empanelment status: {{ ifa?.empanelmentStatus }}
                </div>
            </div>
            <div class="ifa-tag-container">
                <h4>Tags</h4>
                <div>
                    <mat-chip-list *ngIf="ifa?.tags?.length > 0">
                        <mat-chip
                            *ngFor="let tag of ifa?.tags"
                            (removed)="onRemoveTag(ifa, tag)"
                        >
                            {{ tag.tagName }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <div
                        class="no-data"
                        *ngIf="!ifa || ifa?.tags?.length === 0"
                    >
                        No tags added
                    </div>
                </div>
                <div class="text-center">
                    <button
                        mat-raised-button
                        color="primary"
                        class="mat-button-small margin-top-10"
                        (click)="openAddTagDialog(ifa, 'ADD')"
                    >
                        Add Tag
                    </button>
                </div>
            </div>
            <div class="ifa-tag-container">
                <h4>Device Information</h4>
                <ng-template
                    ngFor
                    let-device
                    [ngForOf]="ifa?.device"
                    *ngIf="ifa?.device?.length > 0"
                >
                    <div class="align-h margin-bottom-10">
                        <div class="stretch">Device ID: {{ device?.deviceId }}</div>
                        <div class="stretch">OS Name: {{ device?.osName }}</div>
                        <div class="align-h width-200">
                            <div class="stretch">
                                <button
                                    mat-icon-button
                                    [color]="!device?.status ? 'primary': 'secondary'"
                                    (click)="openBlockOrUnblockDialog(ifa, device)"
                                >
                                    <mat-icon>block</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <div
                    class="no-data"
                    *ngIf="!ifa || ifa?.device?.length === 0"
                >
                    No Device Information
                </div>
            </div>
        </ng-template>
    </mat-expansion-panel>
</mat-accordion>
